import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Partnercard from "./PartnerCard";
import laptopImg from "../../Assets/partners.png";
import Toolstack from "./Toolstack";
import Card from "react-bootstrap/Card";



function Partners() {

   return (
   
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Partners with<strong className="purple"> Purpose</strong>
            </h1>
            <Partnercard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
             <img src={laptopImg} alt="about" className="img-fluid" />
          
            </Col>
      
                  
      
        </Row>
        <h1 className="project-heading">
          How we <strong className="purple">Connect</strong> with Partners
        </h1>

       <Card className="quote-card-view">
             <Card.Body>
               <blockquote className="blockquote mb-0">
                 <p className="about-text">
                  <li><span className="purple">Community-Building Activities</span></li>
                  From homework tutoring and youth tech clubs to urban gardening, our open events bring neighbors together, 
                  nurture friendships, and inspire collective service.
                 </p>
       
                 <p className="about-text">
                  <li><span className="purple">Social Action & Dialogue</span></li>
                  We collaborate with organizations and thought leaders to address critical issues such as technological inequality and economic justice, fostering conversations that lead to meaningful solutions.
                 </p>

                 <p className="about-text">
                  <li><span className="purple">Collaboration with Tech Companies</span></li>
                  We work alongside technology partners who share our vision of inclusive social and economic development, creating tools and opportunities that serve communities.
                 </p>

                 <p className="about-text">
                  <li><span className="purple">Grassroots Outreach</span></li>
                 Through public events, community meetings, and one-on-one conversations, we spread our mission and attract those who share our passion for positive change.
                 </p>            
                 
                 <footer className="blockquote-footer"></footer>
               </blockquote>
             </Card.Body>
           </Card>

        <h1 className="project-heading">
          <strong className="purple">Our</strong> Partners
        </h1>
        <Toolstack />

        {/* <Github /> */}
      </Container>
    </Container>
  

  );
}

export default Partners;
